import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialInstitutionItemCategoriesByTrialInstitutionId: ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdActionCreator = (trialInstitutionId) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID,
            trialInstitutionId
        }
    },
    LoadSuccess: ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdSuccessActionCreator = (formData, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID_SUCCESS,
            formData,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialInstitutionItemCategoriesClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCATEGORIES_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialInstitutionItemCategoriesFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALINSTITUTIONITEMCATEGORIES_FILTER,
            formFilter
        }
    };


export const
    ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID = "ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID",
    ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID_SUCCESS = "ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID_SUCCESS",
    ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID_FAILURE = "ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID_FAILURE",

    ACTION_TRIALINSTITUTIONITEMCATEGORIES_CLEAR = "ACTION_TRIALINSTITUTIONITEMCATEGORIES_CLEAR",

    ACTION_TRIALINSTITUTIONITEMCATEGORIES_FILTER = "ACTION_TRIALINSTITUTIONITEMCATEGORIES_FILTER";

export interface ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdAction {
    type: "ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID";
    trialInstitutionId?: number;
}

export interface ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdActionCreator {
    (trialInstitutionId?: number): ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdAction;
}

export interface ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdSuccessAction {
    type: "ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID_SUCCESS";
    formData: Dtos.TrialInstitutionItemCategory[];
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionItemCategory[],
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdSuccessAction;
}

export interface ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdFailureAction {
    type: "ACTION_TRIALINSTITUTIONITEMCATEGORIES_LOAD_BY_TRIALINSTITUTIONID_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdFailureAction;
}

export interface ITrialInstitutionItemCategoriesClearAction {
    type: "ACTION_TRIALINSTITUTIONITEMCATEGORIES_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialInstitutionItemCategoriesClearActionCreator {
    (propertiesToClear?: string[]): ITrialInstitutionItemCategoriesClearAction;
}

export interface ITrialInstitutionItemCategoriesFilterActionCreator {
    (formFilter: IFormFilter): ITrialInstitutionItemCategoriesFilterAction;
}

export interface ITrialInstitutionItemCategoriesFilterAction {
    type: "ACTION_TRIALINSTITUTIONITEMCATEGORIES_FILTER";
    formFilter: IFormFilter;
}

export type TrialInstitutionItemCategoryActions =
    ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdAction |
    ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdSuccessAction |
    ITrialInstitutionItemCategoriesLoadByTrialInstitutionIdFailureAction |
    ITrialInstitutionItemCategoriesClearAction |
    ITrialInstitutionItemCategoriesFilterAction;